import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";

const FormLabel = () => {
  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* BASIC LABELS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Basic Form Labels</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Simple Label</label>
            <label className="block text-sm font-medium text-slate-300 mb-2">Email Address</label>
            <input type="email" className="w-full px-3 py-2 border border-slate-600 rounded-lg bg-slate-950" placeholder="you@example.com" />
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<label className="block text-sm font-medium text-slate-300 mb-2">
  Email Address
</label>
<input type="email" className="w-full px-3 py-2 border border-slate-600 rounded-lg" />`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Label with Hint</label>
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-1">Username</label>
              <span className="text-xs text-slate-500 mb-2 block">3-20 characters, alphanumeric</span>
              <input type="text" className="w-full px-3 py-2 border border-slate-600 rounded-lg bg-slate-950" />
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<label className="text-sm font-medium text-slate-300">Username</label>
<span className="text-xs text-slate-500">3-20 characters</span>
<input type="text" className="w-full px-3 py-2 border rounded-lg" />`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Label with Icon</label>
            <label className="flex items-center text-sm font-medium text-slate-300 mb-2">
              <span className="mr-2"></span>
              Password
            </label>
            <input type="password" className="w-full px-3 py-2 border border-slate-600 rounded-lg bg-slate-950" />
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<label className="flex items-center text-sm font-medium">
  <span className="mr-2"></span>
  Password
</label>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Small Label Variant</label>
            <label className="block text-xs font-semibold text-slate-400 uppercase mb-2 tracking-wider">First Name</label>
            <input type="text" className="w-full px-3 py-2 border border-slate-600 rounded-lg bg-slate-950 text-sm" />
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<label className="text-xs font-semibold text-slate-400 uppercase tracking-wider">
  First Name
</label>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Large Label</label>
            <label className="block text-lg font-bold text-slate-200 mb-3">Full Name</label>
            <input type="text" className="w-full px-4 py-3 border border-slate-600 rounded-lg bg-slate-950 text-lg" />
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<label className="block text-lg font-bold text-slate-200 mb-3">
  Full Name
</label>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Label with Badge</label>
            <div className="flex justify-between items-center mb-2">
              <label className="text-sm font-medium text-slate-300">Company</label>
              <span className="text-xs bg-amber-900 text-amber-200 px-2 py-1 rounded">Required</span>
            </div>
            <input type="text" className="w-full px-3 py-2 border border-slate-600 rounded-lg bg-slate-950" />
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="flex justify-between items-center">
  <label className="text-sm font-medium">Company</label>
  <span className="bg-amber-900 text-amber-200 px-2 py-1 rounded">Required</span>
</div>`} />
          </div>
        </div>
      </div>

      {/* REQUIRED VS OPTIONAL */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Required & Optional Labels</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Required Asterisk</label>
            <label className="block text-sm font-medium text-slate-300 mb-2">Email <span className="text-red-500">*</span></label>
            <input type="email" className="w-full px-3 py-2 border border-slate-600 rounded-lg bg-slate-950" />
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<label>Email <span className="text-red-500">*</span></label>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Optional Label</label>
            <label className="block text-sm font-medium text-slate-300 mb-2">Phone <span className="text-slate-500">(optional)</span></label>
            <input type="tel" className="w-full px-3 py-2 border border-slate-600 rounded-lg bg-slate-950" />
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<label>Phone <span className="text-slate-500">(optional)</span></label>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Colored Required</label>
            <div className="flex justify-between mb-2">
              <label className="text-sm font-medium text-slate-300">Password</label>
              <span className="text-xs text-amber-400 font-medium">MUST FILL</span>
            </div>
            <input type="password" className="w-full px-3 py-2 border border-amber-600 rounded-lg bg-slate-950" />
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<label className="text-sm font-medium">Password</label>
<span className="text-xs text-amber-400">MUST FILL</span>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Multiple Required</label>
            <div className="space-y-3">
              <div>
                <label className="text-sm text-slate-300">Address <span className="text-red-500">*</span></label>
              </div>
              <div>
                <label className="text-sm text-slate-300">City <span className="text-red-500">*</span></label>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<label className="text-sm">Address <span className="text-red-500">*</span></label>
<label className="text-sm">City <span className="text-red-500">*</span></label>`} />
          </div>
        </div>
      </div>

      {/* COLORED VARIANTS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6"> Colored Label Variants</h2>
        <div className="grid grid-cols-1 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <div className="flex flex-wrap gap-6">
              <div className="flex-1 min-w-[150px]">
                <label className="text-sm font-medium text-amber-400 mb-2 block">Amber Label</label>
                <input type="text" className="w-full px-3 py-2 border border-amber-600 rounded-lg bg-slate-950" />
              </div>
              <div className="flex-1 min-w-[150px]">
                <label className="text-sm font-medium text-orange-400 mb-2 block">Orange Label</label>
                <input type="text" className="w-full px-3 py-2 border border-orange-600 rounded-lg bg-slate-950" />
              </div>
              <div className="flex-1 min-w-[150px]">
                <label className="text-sm font-medium text-yellow-400 mb-2 block">Yellow Label</label>
                <input type="text" className="w-full px-3 py-2 border border-yellow-600 rounded-lg bg-slate-950" />
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<label className="text-sm font-medium text-amber-400">Amber Label</label>
<input type="text" className="border border-amber-600" />`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormLabel;


